import * as React from 'react';

type daysCountForFreeParkingLabelProps = {
    containerId: string,
};

function fetchContainerDescription(contentLink: string) {
    return new Promise<{
        daysCountForFreeParkingText: string
    }>((resolve, reject) => {
        const options = {
            method: 'GET',
        };

        fetch(contentLink, options)
            .then((res) => res.json())
            .then(({
                       daysCountForFreeParkingText
                   }) => {
                resolve({
                    daysCountForFreeParkingText
                });
            });
    });
}

export const DaysCountForFreeParkingLabel = (
    {
        containerId
    }: daysCountForFreeParkingLabelProps
) => {
    const requestAbortController = React.useRef<AbortController | null>(null);
    const [daysCountForFreeParkingText, setDaysCountForFreeParkingText] = React.useState('');

    const fetchContainerDescriptionByLink = (contentLink: string) => {
        const controller = new AbortController();
        fetchContainerDescription(contentLink)
            .then(({
                       daysCountForFreeParkingText,
                   }) => {
                setDaysCountForFreeParkingText(daysCountForFreeParkingText ?? '');
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    throw error;
                }
            });

        requestAbortController.current = controller;
    };

    React.useEffect(() => {
        setDaysCountForFreeParkingText('');
        if (containerId !== '--') {
            fetchContainerDescriptionByLink('container'.concat('/', containerId));
        }
        return () => requestAbortController.current?.abort();
    }, [containerId]);

    return (
        <>
            {daysCountForFreeParkingText !== '' && <span className="information-about-free-days">
                <span>{daysCountForFreeParkingText}</span>
            </span>
            }
        </>
    );
}
